<template>
  <v-card hover class="d-flex mx-auto" color="transparent" light :max-width="cardWidth" @click="changeViewer">
    <v-card-text class="text-center">
      <v-icon x-large class="align-center justify-center my-5" color="pink">{{ cardIcon }}</v-icon>
      <v-spacer></v-spacer>
      <p class="my-2 title ">{{ $vuetify.lang.t(cardTitle) }}</p>
      <p class="subtitle-1 font-weight-light">
        {{ $vuetify.lang.t(cardDescription) }}
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiMap, mdiCellphoneAndroid, mdiChartBar, mdiAccountClock } from '@mdi/js'

export default {
  name: 'functionalityCard',
  props: {
    type: {
      type: String,
      validator: value => {
        return ['map', 'phone', 'stats', 'personification'].includes(value)
      }
    }
  },
  data: () => ({
    mdiMap: mdiMap,
    mdiCellphoneAndroid: mdiCellphoneAndroid,
    mdiChartBar: mdiChartBar,
    mdiAccountClock: mdiAccountClock
  }),
  computed: {
    mobile () {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    },
    cardIcon () {
      switch (this.type) {
        case 'map':
          return this.mdiMap
        case 'phone':
          return this.mdiCellphoneAndroid
        case 'stats':
          return this.mdiChartBar
        case 'personification':
          return this.mdiAccountClock
        default:
          return this.mdiMap
      }
    },
    cardTitle () {
      return `$vuetify.landing.functionality.${this.type}.title`
    },
    cardDescription () {
      return `$vuetify.landing.functionality.${this.type}.description`
    },
    cardWidth () {
      if (this.mobile) {
        return 250
      } else {
        return 350
      }
    }
  },
  methods: {
    changeViewer () {
      this.$emit('card-clicked', this.type)
    }
  }
}
</script>

<style scoped>

</style>
